var map = {
	"./appIcon-menu--AccountDashboard--active.svg": "608b",
	"./appIcon-menu--AccountDashboard.svg": "1186",
	"./appIcon-menu--Applications--active.svg": "e336",
	"./appIcon-menu--Applications.svg": "e4ab",
	"./appIcon-menu--Components--active.svg": "fdfd",
	"./appIcon-menu--Components.svg": "b315",
	"./appIcon-menu--Contacts--active.svg": "fc48",
	"./appIcon-menu--Contacts.svg": "b928",
	"./appIcon-menu--Integrations--active.svg": "eeb6",
	"./appIcon-menu--Integrations.svg": "561d",
	"./appIcon-menu--Invoicing--active.svg": "f21e",
	"./appIcon-menu--Invoicing.svg": "28a7",
	"./appIcon-menu--Reports--active.svg": "117d",
	"./appIcon-menu--Reports.svg": "5ce6",
	"./appIcon-menu--Revenue--active.svg": "1958",
	"./appIcon-menu--Revenue.svg": "9a2f",
	"./appIcon-menu--Settings--active.svg": "f802",
	"./appIcon-menu--Settings.svg": "e4a1",
	"./appIcon-menu--Subscriptions--active.svg": "92fc",
	"./appIcon-menu--Subscriptions.svg": "5c6cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c54b";